import { useForm } from "react-hook-form";
import CustomSelect from "../custom-select/custom-select";
import CustomTextInput from "../custom-text-input/custom-text-input";
import { forwardRef, useImperativeHandle } from "react";
import CustomButton from "../custom-button/custom-button";
import CustomFileInput from "../custom-file-input/custom-file-input";
import CustomTextarea from "../custom-text-area/custom-text-area";
import CustomRichText from "../custom-rich-text/custom-rich-text";
export const GeneralForm = forwardRef(({ props }, ref) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ criteriaMode: "all", mode: "all" });

  const renderFields = (field) => {
    field.register = register;
    field.errors = errors;
    field.setValue = setValue;
    switch (field.type) {
      case "text":
        return <CustomTextInput props={{ ...field }} />;
      case "textarea":
        return <CustomTextarea props={{ ...field }} />;
      case "richtext":
        return <CustomRichText props={{ ...field }} />;
      case "file":
        return <CustomFileInput props={{ ...field }} />;
      case "select":
        return <CustomSelect props={{ ...field }} />;
      default:
        return <CustomTextInput props={{ ...field }} />;
    }
  };

  useImperativeHandle(ref, () => ({
    submitForm: async () => {
      return await handleSubmit(async (data) => {
        await props.onSubmit(data);
      })();
    },
  }));

  return (
    <form
      onSubmit={handleSubmit(props.onSubmit)}
      className={`${
        props.isHorizontal
          ? "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-1 w-full "
          : "grid grid-cols-1 gap-y-1 w-full "
      }`}
    >
      {props.fields &&
        props.fields.map((field, key) => (
          <div key={key} className={props.isHorizontal && (field.type === "richtext" || field.type === "textarea") ? "md:col-span-2" : ""}>
            <label className="w-fit whitespace-nowrap text-gray-600">
              {field.label}
              {field.isRequired && (
                <span className="!text-red-500 !font-bold ml-1">*</span>
              )}
              :
            </label>
            {renderFields(field)}
          </div>
        ))}

      {!props.hiddenSubmitBtn && (
        <div className="w-full flex flex-row justify-end">
          <div className="w-32">
            <CustomButton props={{ title: "Lưu" }} />
          </div>
        </div>
      )}
    </form>
  );
});

GeneralForm.displayName = "GeneralForm";

export default GeneralForm;
